import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * Branded loading view shared by admin and user areas.
 *
 * Props:
 *  - symbolClass: optional Bootstrap-icon class shown in the spinner center
 *  - title: main heading text
 *  - subtitle: secondary line of explanatory text
 *  - extra: optional smaller note below the subtitle
 *  - className: extra classes for the outer container
 *  - fullViewport: when true, fills at least the viewport height
 */
export default function LoadingView({
  symbolClass,
  title,
  subtitle,
  extra,
  className,
  fullViewport,
}) {
  return (
    <div
      className={classNames(
        'loading-view d-flex flex-column justify-content-center align-items-center text-center',
        fullViewport && 'min-vh-100',
        className
      )}
    >
      <div className="spinner-container mb-3">
        <div className="spinner-circle" />
        {symbolClass && (
          <i className={classNames('loading-symbol', symbolClass)} />
        )}
      </div>

      {title && <h5 className="loading-title mb-1">{title}</h5>}
      {subtitle && (
        <p className="loading-subtitle text-muted mb-0">{subtitle}</p>
      )}
      {extra && (
        <small className="loading-subtitle text-muted mt-1">{extra}</small>
      )}
    </div>
  );
}

LoadingView.propTypes = {
  symbolClass: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  extra: PropTypes.string,
  className: PropTypes.string,
  fullViewport: PropTypes.bool,
};

LoadingView.defaultProps = {
  symbolClass: null,
  title: 'Loading',
  subtitle: null,
  extra: null,
  className: '',
  fullViewport: false,
};
